<template>
  <div>
    <button
      v-if="canUserEdit"
      v-b-tooltip.hover
      :v-b-modal="modalName"
      class="btn btn-primary"
      placement="bottom"
      title="Regeln aus Vorlage importieren"
      type="button"
      @click="showModal(modalName)"
    >
      <i class="fas fa-file-import" />
    </button>

    <b-modal
      :id="modalName"
      :ref="modalName"
      hide-footer
      no-fade
      title="Regeln aus Vorlage importieren"
      @hide="errorObject = null"
    >
      <template v-if="createErrorObject">
        <u-error-handling :error-object="createErrorObject" />
        <div
          id="my-collapse"
          class="mb-2"
          style="border: 1px solid lightgray; padding: 5px"
        >
          <b>Folgende Bedingungen müssen erfüllt sein, dass der Import
            funktioniert</b>
          <ul>
            <li>
              Es muss ein Stukturelement für Jahr (Titel = Jahr/Année/Anno)
              vorhanden sein
            </li>
            <li>
              Das Eingabekriterium für Jahr sollte mindestens das Jahr
              enthalten, das importiert werden soll
            </li>
            <li>
              Es muss ein Stukturelement für Kanton (Titel =
              Kanton/Canton/Cantone) vorhanden sein
            </li>
            <li>
              Es muss ein Stukturelement für Bezirk (Titel =
              Feiertagsbezirk/Bezirk/District/Distretto) vorhanden sein
            </li>
          </ul>

          <b>Zusätzlich müssen auf der Regelkonfiguration die Stukturelemente
            für Jahr, Kanton und Bezirk vorhanden sein.</b>
        </div>
      </template>
      <u-loader v-if="isLoading" />
      <div
        v-else
        class="d-block mb-4"
      >
        <button
          v-b-toggle.my-collapse
          v-b-tooltip.hover
          class="btn mr-4 InformationButton float-right"
          placement="bottom"
          title="Info"
          type="button"
        >
          <i class="fas fa-info-circle" />
        </button>
        <b-collapse
          id="my-collapse"
          :visible="errorObject != null"
          class="mb-2"
          style="border: 1px solid lightgray; padding: 5px"
        >
          <b>Folgende Bedingungen müssen erfüllt sein, dass der Import
            funktioniert</b>
          <ul>
            <li>
              Es muss ein Stukturelement für Jahr (Titel = Jahr/Année/Anno)
              vorhanden sein
            </li>
            <li>
              Das Eingabekriterium für Jahr sollte mindestens das Jahr
              enthalten, das importiert werden soll
            </li>
            <li>
              Es muss ein Stukturelement für Kanton (Titel =
              Kanton/Canton/Cantone) vorhanden sein
            </li>
            <li>
              Es muss ein Stukturelement für Bezirk (Titel =
              Feiertagsbezirk/Bezirk/District/Distretto) vorhanden sein
            </li>
          </ul>

          <b>Zusätzlich müssen auf der Regelkonfiguration die Stukturelemente
            für Jahr, Kanton und Bezirk vorhanden sein.</b>
        </b-collapse>
        <div v-if="errorObject">
          <u-error-handling :error-object="errorObject" />
        </div>
        <div>Bitte wählen sie eine Vorlage zum Importieren aus:</div>

        <v-select
          v-model="selectedTemplateId"
          :items="templates"
          item-text="name"
          item-value="id"
          label="Vorlage wählen"
        />
      </div>
      <b-button
        variant="success"
        @click="importRules"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="
          () => {
            errorObject = null;
            hideModal(modalName);
          }
        "
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { CreateFromTemplate } from "@/services/minimum.wage.services/template.minimum.wages.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  mixins: [MinimumWageMixin],
  props: {
    name: {
      type: String,
      default: "modal",
    },
    ruleConfigId: {
      type: Number,
      default: null,
    },
    ruleGroupId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      errorObject: null,
      id: null,
      isLoading: false,
      selectedTemplateId: null,
      modalName: "importModal_" + this.name,
      createErrorObject: null,
    };
  },
  computed: {
    templates() {
      return this.$store.getters.getTemplatesByType(0);
    },
  },
  methods: {
    importRules() {
      let that = this;
      this.isLoading = true;

      // create rules from template
      CreateFromTemplate(
        this.selectedTemplateId,
        this.contractId,
        this.versionId,
        this.editionId,
        this.ruleConfigId,
        this.ruleGroupId,
        () => {
          that.hideModal(that.modalName);
          this.isLoading = false;
          that.$eventBus.$emit("rulesChanged");
        },
        (error) => {
          that.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped>
.InformationButton {
  background-color: transparent;
  color: #326fff;
  border: none;
  font-size: 25px;
  padding: 0px;
  height: 25px;
}

.InformationButton:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
